import { createRequiredContext } from "utils/createRequiredContext";
import { use } from "react";
import type { PatientActivityStatusFilterState } from "./useStatusFilters";

/** Patient activity filter context properties. */
export interface PatientActivityFilterContextProps {
    /** The current state of all of the display filters. */
    readonly statusFilter: PatientActivityStatusFilterState;

    /** The list of active filters that should be applied to the API request. */
    readonly status: (keyof PatientActivityStatusFilterState)[];

    /** Function to toggle the status of a display filter. */
    readonly toggleStatus: (filterType: keyof PatientActivityStatusFilterState, enabled: boolean) => void;

    /** Patient name filter. */
    readonly patientName: string;

    /** Callback to set patient name filter. */
    readonly setPatientName: React.Dispatch<React.SetStateAction<string>>;
}

/** Patient activity filter context. */
export const PatientActivityFilterContext = createRequiredContext<PatientActivityFilterContextProps>(
    "Patient Activity Filter Context",
);
PatientActivityFilterContext.displayName = "Patient Activity Filter Context";

/** Provide access to patient activity filter context. */
export function usePatientActivityFilterContext() {
    return use(PatientActivityFilterContext);
}
